import { UsageReducer } from '../interfaces';
import { createReducer } from '@reduxjs/toolkit';

const initialState: UsageReducer = {
  status: {
    loading: false,
    error: false,
    done: false,
  },
  data: null,
};

const usageReducer = createReducer(initialState, {
  GET_MY_USE_PENDING: (state) => {
    state.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  GET_MY_USE_FULFILLED: (state, action) => {
    state.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.data = action.payload.data;
  },

  GET_MY_USE_REJECTED: (state, action) => {
    state.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.data = action.payload.data;
  },
  GET_ALL_MY_USE_PENDING: (state) => {
    state.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  GET_ALL_MY_USE_FULFILLED: (state, action) => {
    state.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.data = action.payload.data;
  },

  GET_ALL_MY_USE_REJECTED: (state, action) => {
    state.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.data = action.payload.data;
  },
});

export default usageReducer;
